var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cockpit" }, [
    _c("div", { staticClass: "index_title" }, [
      _vm._v("黄石市公共资源交易智慧监管总舱"),
    ]),
    _c("div", { staticClass: "index_content" }, [
      _c(
        "div",
        { staticClass: "index_left" },
        _vm._l(_vm.leftData, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "index_left_row",
              on: {
                click: function ($event) {
                  return _vm.jump(item.img)
                },
              },
            },
            [
              _c("div", [_vm._v(_vm._s(item.name))]),
              _c("img", { attrs: { src: item.url, alt: "" } }),
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "index_middle" }, [
        _c("div", [
          _c("img", {
            attrs: {
              src: require("@/assets/img/cockpit/index/right.png"),
              alt: "",
            },
          }),
          _c("img", {
            attrs: {
              src: require("@/assets/img/cockpit/index/left_line.png"),
              alt: "",
            },
          }),
        ]),
        _c("div", [
          _c("img", {
            attrs: {
              src: require("@/assets/img/cockpit/index/right_line.png"),
              alt: "",
            },
          }),
          _c("img", {
            attrs: {
              src: require("@/assets/img/cockpit/index/left.png"),
              alt: "",
            },
          }),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "index_right" },
        _vm._l(_vm.rightData, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "index_left_row",
              on: {
                click: function ($event) {
                  return _vm.jump(item.img)
                },
              },
            },
            [
              _c("img", { attrs: { src: item.url, alt: "" } }),
              _c("div", [_vm._v(_vm._s(item.name))]),
            ]
          )
        }),
        0
      ),
    ]),
    _c(
      "div",
      { staticClass: "footerBottom" },
      _vm._l(_vm.footerTitle, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            on: {
              click: function ($event) {
                return _vm.changeActive(item.img)
              },
              mouseenter: function ($event) {
                return _vm.changeImg(index, 1)
              },
              mouseleave: function ($event) {
                return _vm.changeImg(index, 2)
              },
            },
          },
          [
            item.isShow == false
              ? _c("img", { attrs: { src: item.url, alt: "" } })
              : _c("img", { attrs: { src: item.url1, alt: "" } }),
            _c("div", { class: item.isShow == false ? "" : "active" }, [
              _vm._v(_vm._s(item.name)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }